import { render, staticRenderFns } from "./SendHelpTutorial.vue?vue&type=template&id=3ffc6037&"
import script from "./SendHelpTutorial.vue?vue&type=script&lang=js&"
export * from "./SendHelpTutorial.vue?vue&type=script&lang=js&"
import style0 from "./SendHelpTutorial.vue?vue&type=style&index=0&id=3ffc6037&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports